import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  inactiveCustomers: {
    data: [],
    isFetching: false,
    pagination: {
      page: 1,
      perPage: 50,
      total: 0,
      totalPages: 0,
    },
  },
  archivedInvoices: {
    data: [],
    isFetching: false,
    pagination: {
      page: 1,
      perPage: 20,
      total: 0,
      totalPages: 0,
    },
  },
  auditLogs: {
    data: [],
    isFetching: false,
    pagination: {
      page: 1,
      perPage: 50,
      total: 0,
      totalPages: 0,
    },
  },
};

const payAdminManagement = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.PAYADMIN_SET_INACTIVE_CUSTOMERS:
      return {
        ...state,
        inactiveCustomers: {
          ...state.inactiveCustomers,
          ...action.payload,
        },
      };

    case ReducersTypes.PAYADMIN_SET_ARCHIVED_INVOICES:
      return {
        ...state,
        archivedInvoices: {
          ...state.archivedInvoices,
          ...action.payload,
        },
      };

    case ReducersTypes.PAYADMIN_SET_AUDIT_LOGS:
      return {
        ...state,
        auditLogs: {
          ...state.auditLogs,
          ...action.payload,
        },
      };

    case ReducersTypes.PAYADMIN_RESET_INACTIVE_CUSTOMERS:
      return {
        ...state,
        inactiveCustomers: initialState.inactiveCustomers,
      };

    case ReducersTypes.PAYADMIN_RESET_ARCHIVED_INVOICES:
      return {
        ...state,
        archivedInvoices: initialState.archivedInvoices,
      };

    case ReducersTypes.PAYADMIN_RESET_AUDIT_LOGS:
      return {
        ...state,
        auditLogs: initialState.auditLogs,
      };

    case ReducersTypes.PAYADMIN_RESET_ALL:
      return initialState;

    default:
      return state;
  }
};

export default payAdminManagement;
